import angular from 'angular';

export default angular.module('cms.creator.historyStorage', [])
    .factory('historyStorage', function ($rootScope, $timeout) {

        this.stack = [];
        this.counter = 0;

        const MAX_STACK_COUNT = 50;

        let next = () => {
            if (this.stack.length > 1) {
                if (this.counter < -1 || this.counter > this.stack.length) {
                    this.counter = 0;
                }
                let snapshot = this.stack[++this.counter];

                if (snapshot) {
                    $rootScope.$broadcast('history-storage-change', {snapshot: angular.copy(snapshot)});
                }
            }
        };

        let back = () => {
            if (this.counter > 0) {
                this.counter--;


                let snapshot = this.stack[this.counter];
                if (snapshot) {
                    $rootScope.$broadcast('history-storage-change', {snapshot: angular.copy(snapshot)});
                }
            }
        };

        let add = (item) => {
            let lastElement = this.stack[this.counter];

            if(!lastElement) {
                lastElement = { content: {}};
            }

            let copy = angular.copy(item);

            if (!angular.equals(lastElement, copy)) {
                this.stack[++this.counter] = copy;

                this.stack.splice(this.counter + 1);

                if (this.counter > MAX_STACK_COUNT) {
                    this.stack.shift();
                    this.counter--;
                }
            }
        };

        let register = (element, page, contentScope) => {
            this.stack = [];
            this.counter = -1;

            element.on('mousedown', (el) => {
                if ($(el.target).hasClass('undo-redo')) {
                    return;
                }

                add(page());
            });

            contentScope.$on('sections-library.drop-model', (el, target, source) => {
                $timeout(() => {
                    add(page());
                });
            });

            contentScope.$on('content-changed', (event, value) => {
                $timeout(() => {
                    add(page());
                });
            })

        };

        let clear = () => {
          this.stack = [];
          this.counter = -1;
        };

        let getStackLength = () => {
            return this.stack.length;
        };

        let getCounter = () => {
            return this.counter;
        };

        return {
            next: next,
            back: back,
            add: add,
            register: register,
            getStackLength: getStackLength,
            getCounter: getCounter,
            clear: clear
        };

    })
    .name


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/UndoRedo/historyStorage.js